function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1908(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 39.83,
    height: 27.38,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5633333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 13.69
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 27.38,
    width: 39.83,
    height: 32.4,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 43.58
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 59.77,
    width: 39.83,
    height: 34.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 76.99000000000001
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 94.22,
    width: 39.83,
    height: 37.46,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.162222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 112.95
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 131.68,
    width: 39.83,
    height: 38.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.5725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 150.82500000000002
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 169.97,
    width: 39.83,
    height: 38.92,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.865
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 189.43
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 208.89,
    width: 39.83,
    height: 40.63,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.638333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 229.20499999999998
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 249.52,
    width: 39.83,
    height: 43.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.638333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 271.03000000000003
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 292.54,
    width: 39.83,
    height: 43.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.9575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 314.095
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 335.65,
    width: 39.83,
    height: 43.84,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.965999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 357.57
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 379.5,
    width: 39.83,
    height: 48.23,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.965999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 403.615
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 427.73,
    width: 39.83,
    height: 51.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9829999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 453.33000000000004
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 478.93,
    width: 39.83,
    height: 52.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9829999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 504.995
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 531.05,
    width: 39.83,
    height: 55.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.9575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 558.625
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 586.2,
    width: 39.83,
    height: 56.27,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 614.335
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 642.47,
    width: 39.83,
    height: 57.53,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3191666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.915,
    y: 671.235
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.83,
    y: 0,
    width: 43.54,
    height: 53.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.4425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.599999999999994,
    y: 26.555
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.37,
    y: 0,
    width: 43.65,
    height: 53.11,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.235714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.19500000000001,
    y: 26.555
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.03,
    y: 0,
    width: 44.13,
    height: 53.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.903333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 149.095,
    y: 26.555
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.15,
    y: 0,
    width: 47.6,
    height: 53.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.95000000000002,
    y: 26.555
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.75,
    y: 0,
    width: 48.73,
    height: 53.11,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.872999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.115,
    y: 26.555
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.48,
    y: 0,
    width: 49.75,
    height: 53.11,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.291666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 292.355,
    y: 26.555
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.24,
    y: 0,
    width: 50.92,
    height: 53.11,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.973333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.7,
    y: 26.555
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368.16,
    y: 0,
    width: 51.65,
    height: 53.11,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.608333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 393.985,
    y: 26.555
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 419.81,
    y: 0,
    width: 52.9,
    height: 53.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.877777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 446.26,
    y: 26.555
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 472.71,
    y: 0,
    width: 54.47,
    height: 53.11,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.63875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.945,
    y: 26.555
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527.18,
    y: 0,
    width: 56,
    height: 53.11,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.622
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 555.18,
    y: 26.555
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.18,
    y: 0,
    width: 57.72,
    height: 53.11,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.851666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 612.04,
    y: 26.555
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 640.89,
    y: 0,
    width: 59.11,
    height: 53.11,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.851666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.4449999999999,
    y: 26.555
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.83,
    y: 53.11,
    width: 60.89,
    height: 54.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.275,
    y: 80.5
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.83,
    y: 107.89,
    width: 60.89,
    height: 56.05,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.341666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.275,
    y: 135.915
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.83,
    y: 163.94,
    width: 60.89,
    height: 56.15,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.275,
    y: 192.015
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.83,
    y: 220.09,
    width: 60.89,
    height: 57.07,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.414
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.275,
    y: 248.625
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.83,
    y: 277.16,
    width: 60.89,
    height: 57.1,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.516666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.275,
    y: 305.71000000000004
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.83,
    y: 334.26,
    width: 60.89,
    height: 58.89,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.275,
    y: 363.705
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.83,
    y: 393.14,
    width: 60.89,
    height: 59.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.275,
    y: 422.885
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.83,
    y: 452.63,
    width: 60.89,
    height: 60.93,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.535454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.275,
    y: 483.09499999999997
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.83,
    y: 513.56,
    width: 60.89,
    height: 61.44,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.148333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.275,
    y: 544.28
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.83,
    y: 574.99,
    width: 60.89,
    height: 62.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.61125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.275,
    y: 606.12
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.83,
    y: 637.26,
    width: 60.89,
    height: 62.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.178
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.275,
    y: 668.63
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.72,
    y: 53.11,
    width: 61.46,
    height: 62.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.292
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.45,
    y: 84.24
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.17,
    y: 53.11,
    width: 65.19,
    height: 62.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.376666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.765,
    y: 84.24
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.37,
    y: 53.11,
    width: 65.19,
    height: 62.26,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.7825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.96500000000003,
    y: 84.24
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.56,
    y: 53.11,
    width: 65.35,
    height: 62.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.226
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 325.235,
    y: 84.24
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.91,
    y: 53.11,
    width: 65.76,
    height: 62.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.894285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.79,
    y: 84.24
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.67,
    y: 53.11,
    width: 68.28,
    height: 62.26,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.917777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 457.81,
    y: 84.24
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.95,
    y: 53.11,
    width: 68.72,
    height: 62.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.452
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.31,
    y: 84.24
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.67,
    y: 53.11,
    width: 68.93,
    height: 62.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.7825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 595.135,
    y: 84.24
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 629.6,
    y: 53.11,
    width: 70.4,
    height: 62.26,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.376666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 664.8000000000001,
    y: 84.24
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.72,
    y: 115.37,
    width: 72.04,
    height: 61.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.752857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.74,
    y: 146.005
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.72,
    y: 176.65,
    width: 72.04,
    height: 61.84,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.871111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.74,
    y: 207.57
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.72,
    y: 238.48,
    width: 72.04,
    height: 63.51,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.93875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.74,
    y: 270.235
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.72,
    y: 301.99,
    width: 72.04,
    height: 63.61,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.601666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.74,
    y: 333.795
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.72,
    y: 365.61,
    width: 72.04,
    height: 63.78,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.798181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.74,
    y: 397.5
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.72,
    y: 429.38,
    width: 72.04,
    height: 65.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.384285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.74,
    y: 462.225
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.72,
    y: 495.07,
    width: 72.04,
    height: 67.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.537777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.74,
    y: 528.99
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.72,
    y: 562.91,
    width: 72.04,
    height: 68.54,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.791428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.74,
    y: 597.18
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.72,
    y: 631.46,
    width: 72.04,
    height: 68.54,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.5675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.74,
    y: 665.73
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.76,
    y: 115.37,
    width: 70,
    height: 70.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 207.76,
    y: 150.75
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.76,
    y: 115.37,
    width: 73.15,
    height: 70.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.152000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.335,
    y: 150.75
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.92,
    y: 115.37,
    width: 74.94,
    height: 70.76,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.793333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 353.39,
    y: 150.75
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.85,
    y: 115.37,
    width: 75.29,
    height: 70.76,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.793333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 428.495,
    y: 150.75
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.14,
    y: 115.37,
    width: 76.14,
    height: 70.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.793333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 504.21,
    y: 150.75
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.29,
    y: 115.37,
    width: 78.5,
    height: 70.76,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.152000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 581.54,
    y: 150.75
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.79,
    y: 115.37,
    width: 79.21,
    height: 70.76,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.108571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.395,
    y: 150.75
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.76,
    y: 186.14,
    width: 83.13,
    height: 70.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.325,
    y: 221.29
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.76,
    y: 256.44,
    width: 83.13,
    height: 70.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.069999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.325,
    y: 291.685
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.76,
    y: 326.93,
    width: 83.13,
    height: 73.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.22
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.325,
    y: 363.81
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.76,
    y: 400.69,
    width: 83.13,
    height: 73.83,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.22875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.325,
    y: 437.605
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.76,
    y: 474.52,
    width: 83.13,
    height: 74.13,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.354999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.325,
    y: 511.585
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.76,
    y: 548.65,
    width: 83.13,
    height: 75.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.4125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.325,
    y: 586.3
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.76,
    y: 623.95,
    width: 83.13,
    height: 76.05,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.864285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 214.325,
    y: 661.975
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.89,
    y: 186.14,
    width: 70.31,
    height: 90.66,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.031000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 291.04499999999996,
    y: 231.46999999999997
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.19,
    y: 186.14,
    width: 70.88,
    height: 90.66,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.72
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.63,
    y: 231.46999999999997
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.08,
    y: 186.14,
    width: 70.9,
    height: 90.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.53,
    y: 231.46999999999997
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 467.98,
    y: 186.14,
    width: 73.43,
    height: 90.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.17875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 504.69500000000005,
    y: 231.46999999999997
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.41,
    y: 186.14,
    width: 78.93,
    height: 90.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.155000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.875,
    y: 231.46999999999997
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.34,
    y: 186.14,
    width: 79.66,
    height: 90.66,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.931999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.1700000000001,
    y: 231.46999999999997
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.89,
    y: 276.8,
    width: 87.66,
    height: 82.83,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.203333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.71999999999997,
    y: 318.21500000000003
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.89,
    y: 359.63,
    width: 87.66,
    height: 82.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.294
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.71999999999997,
    y: 401.1
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.89,
    y: 442.57,
    width: 87.66,
    height: 84.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.031428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.71999999999997,
    y: 484.68
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.89,
    y: 526.79,
    width: 87.66,
    height: 86.53,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.361428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.71999999999997,
    y: 570.055
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.89,
    y: 613.32,
    width: 87.66,
    height: 86.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.668000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.71999999999997,
    y: 656.6600000000001
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.54,
    y: 276.8,
    width: 83.78,
    height: 92.59,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.968571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 385.43,
    y: 323.095
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.32,
    y: 276.8,
    width: 89.56,
    height: 92.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.794285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 472.1,
    y: 323.095
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 516.88,
    y: 276.8,
    width: 90.75,
    height: 92.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.34375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.255,
    y: 323.095
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 607.63,
    y: 276.8,
    width: 92.37,
    height: 92.59,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.395000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 653.815,
    y: 323.095
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.54,
    y: 369.39,
    width: 108.49,
    height: 79.8,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.959999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.785,
    y: 409.28999999999996
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.54,
    y: 449.19,
    width: 108.49,
    height: 80.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.0375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.785,
    y: 489.34
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.54,
    y: 529.49,
    width: 108.49,
    height: 82,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.785,
    y: 570.49
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.54,
    y: 611.49,
    width: 108.49,
    height: 88.51,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.751666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.785,
    y: 655.745
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.03,
    y: 369.39,
    width: 120.79,
    height: 82.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.33625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 512.425,
    y: 410.735
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 572.83,
    y: 369.39,
    width: 127.17,
    height: 82.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.33625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 636.4150000000001,
    y: 410.735
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.03,
    y: 452.08,
    width: 86.89,
    height: 122.84,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.412857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.47499999999997,
    y: 513.5
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 452.03,
    y: 574.92,
    width: 86.89,
    height: 125.08,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.899090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.47499999999997,
    y: 637.4599999999999
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.92,
    y: 452.08,
    width: 161.08,
    height: 80.51,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.1275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.4599999999999,
    y: 492.335
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.92,
    y: 532.59,
    width: 161.08,
    height: 81.4,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.4599999999999,
    y: 573.2900000000001
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.92,
    y: 614,
    width: 161.08,
    height: 86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.4599999999999,
    y: 657
  }, "\n        Buncombe\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1908);
export default __webpack_public_path__ + "static/media/1908.c593de2c6b945160686af3e6d3493fce.svg";
export { ForwardRef as ReactComponent };